Vue.component('navs', require('./Navs').default);
Vue.component('nav-item', require('./NavItem').default);

Vue.component('navigation-menu', require('./NavigationMenu').default);
Vue.component('button-open-filter', require('./ButtonOpenFilter').default);
Vue.component('button-close-filter', require('./ButtonCloseFilter').default);
Vue.component('button-dropdown-settings-nav', require('./ButtonDropdownSettingsNav').default);
